import { render, staticRenderFns } from "./account-login.vue?vue&type=template&id=265e4a14&scoped=true"
import script from "./account-login.vue?vue&type=script&lang=js"
export * from "./account-login.vue?vue&type=script&lang=js"
import style0 from "./account-login.vue?vue&type=style&index=0&id=265e4a14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265e4a14",
  null
  
)

export default component.exports